<template>
  <div>
    <div class="animated fadeIn">
      <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true" />
    </div>
    <b-row v-if="items.length > 0">
      <b-col cols="12">
        <transition name="slide">
          <b-card header="Lista de clientes">
            <b-row>
              <b-col xl="6" lg="6" md="12" sm="12">
                <b-form-group>
                  <b-input-group size="sm" prepend="Buscar">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="Digite para pesquisar"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col xl="6" lg="6" md="12" sm="12">
                <nav>
                  <b-pagination
                    size="sm"
                    :total-rows="totalRows"
                    :per-page="perPage"
                    v-model="currentPage"
                    prev-text="Anterior"
                    next-text="Próxima"
                    hide-goto-end-buttons
                    align="fill"
                  />
                </nav>
              </b-col>
            </b-row>
            <b-table
              hover
              striped
              bordered
              responsive="sm"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
              :filter="filter"
              :filterIncludedFields="filterOn"
              @filtered="onFiltered"
            >
              <template slot="ativado" slot-scope="data">
                <b-badge
                  :variant="getBadge(data.item.ativado, data.item.islive)"
                >{{ data.item.islive == false ? 'desinstalou' : data.item.ativado == true ? 'ativo' : 'em espera' }}</b-badge>
              </template>
            </b-table>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import itens from "./ClientesData";
import Loading from "vue-loading-overlay";

import axios from "axios";
import * as config from "@/config.json";

export default {
  name: "Clientes",
  components: { Loading },
  data: () => {
    return {
      items: {},
      fields: [
        { key: "cpf", label: "CPF" },
        "nome",
        "sobrenome",
        { key: "ativado", label: "Status" },
        { key: "dataregistro", label: "Registro" }
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      isLoading: false,
      filter: null,
      filterOn: []
    };
  },
  async beforeMount() {
    this.isLoading = true;
    await axios
      .get(
        `${
          config.default.servidor
        }/gerencial/retorna-clientes/${localStorage
          .getItem("enterprise_id")
          .toString()}`,
        {
          headers: {
            Authorization: "Basic c2E6QURNQUNDRVNZUw=="
          }
        }
      )
      .then(response => {
        this.items = response.data.data;
      });
    this.getRowCount(this.items);
    this.isLoading = false;
  },
  computed: {},
  
  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    getBadge(status, islive) {
      console.log("status: " + status);
      console.log("islive: " + islive);
      return islive == 0
        ? "danger"
        : status == 1
        ? "success"
        : status == 0
        ? "secondary"
        : "primary";
    },
    getRowCount(items) {
      this.totalRows = items.length;
    },
    userLink(cpf) {
      // return `cliente/${cpf.toString()}`;
    },
    rowClicked(item) {
      // const userLink = this.userLink(item.cpf);
      // this.$router.push({ path: userLink });
    }
  }
};
</script>
